import * as React from 'react';
import classNames from 'classnames';

import DoubleLinearProgress from '../LinearProgress/DoubleLinearProgress';
import ExistSubscription from './ExistSubscription';
import EmptyData from '../../../../components/EmptyData/EmptyData';
import SubTooltip from '../Tooltip/SubTooltip';

import formateExistSubList from '../../utils/formateExistSubList';

import * as ExistSubscriptionInterface from '../../interfaces/ExistSubscription';

interface Props {
  fetchExistUserSubscription: () => void;
  deleteExistSubscription: (id: number) => void;
  existSubscription: ExistSubscriptionInterface.default[];
  existSubscriptionLoading: boolean;
  editExistSubscription: (id: number) => void;
  editExistSubId: (id: number) => void;
  editExistSubDatetimeFinish: (id: number) => void;
  editExistSubDatetimeFinishValue: Date;
  isMdSize: boolean;
}

function ExistSubscriptionList (props: Props) {

  const {
    deleteExistSubscription,
    existSubscription,
    existSubscriptionLoading,
    editExistSubscription,
    editExistSubId,
    editExistSubDatetimeFinish,
    editExistSubDatetimeFinishValue,
    fetchExistUserSubscription,
    isMdSize,
  } = props;

  const existSubscriptionList = React.useMemo(() => classNames({
    'exist-subscription-list': !isMdSize,
    'exist-subscription-list-md': isMdSize,
  }), [isMdSize]);

  const { activeSub, closedSub } = React.useMemo(
    () => formateExistSubList(existSubscription), [existSubscription]
  );

  return (
    <React.Fragment>
      <h3 className='new-form-title'>
        {'Subscription list:'}
      </h3>
      <div className={existSubscriptionList}>
        {existSubscriptionLoading
          ? <DoubleLinearProgress />
          : activeSub.length || closedSub.length
            ? <React.Fragment>
              <h4 className='new-form-title'>
                {'Active Subscriptions:'}
              </h4>
              { activeSub.length
                ? activeSub
                  .map(subscription => (
                    subscription ? (
                      <ExistSubscription
                        key={subscription.id}
                        editExistSubDatetimeFinishValue={editExistSubDatetimeFinishValue}
                        editExistSubDatetimeFinish={editExistSubDatetimeFinish}
                        editExistSubId={editExistSubId}
                        editExistSubscription={editExistSubscription}
                        deleteExistSubscription={deleteExistSubscription}
                        id={subscription.id}
                        dateFinish={subscription.date_finish}
                        dateStart={subscription.date_start}
                        sub={subscription}
                        subscription={subscription.product_package} />
                    ) : null)
                  ) : <EmptyData message='Empty list' />}
              <br />
              <h4 className='new-form-title'>
                {'Closed Subscriptions:'}
              </h4>
              { closedSub.length
                ? closedSub
                  .map(subscription => (
                    subscription ? (
                      <ExistSubscription
                        key={subscription.id}
                        editExistSubDatetimeFinishValue={editExistSubDatetimeFinishValue}
                        editExistSubDatetimeFinish={editExistSubDatetimeFinish}
                        editExistSubId={editExistSubId}
                        editExistSubscription={editExistSubscription}
                        deleteExistSubscription={deleteExistSubscription}
                        id={subscription.id}
                        dateFinish={subscription.date_finish}
                        dateStart={subscription.date_start}
                        sub={subscription}
                        canceled
                        subscription={subscription.product_package} />
                    ) : null)
                  ) : <EmptyData message='Empty list' />}
            </React.Fragment>
            : (
              <SubTooltip
                title='Reload'
                placement='bottom'
                wrappedNode={
                  <div
                    className='cursor-pointer'
                    onClick={fetchExistUserSubscription}>
                    <EmptyData message='Empty Subscription list' />
                  </div>
                } />
            )}
      </div>
    </React.Fragment>
  );
  
}

export default React.memo(ExistSubscriptionList);
